import { render, staticRenderFns } from "./subjective.vue?vue&type=template&id=122ffc64&scoped=true&"
import script from "./subjective.vue?vue&type=script&lang=js&"
export * from "./subjective.vue?vue&type=script&lang=js&"
import style0 from "./subjective.vue?vue&type=style&index=0&id=122ffc64&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ffc64",
  null
  
)

export default component.exports